export default "__VITE_ASSET__c16c3078__"